import { gql } from '@apollo/client';
export const fetchPriceAlertData = gql`
    query priceAlertTabularData(
        $comparisonPeriodType: SamyaString!
        $periodsList: [Int]!
        $rowDimension: SamyaString!
        $rowAttributeType: SamyaString!
        $filters: JSONString!
        $columnDimension: SamyaString!
        $columnAttributeType: SamyaString!
        $limit: Int!
        $offset: Int!
        $frequency: String!
        $dateRange: [JSONString]!
        $metricType: SamyaString
        $priceType: SamyaString
        $kpiName: SamyaString
        $selectedRow: String!
        $selectedColumn: String!
    ) {
        priceAlertTabularData(
            comparisonPeriodType: $comparisonPeriodType
            periodsList: $periodsList
            rowDimension: $rowDimension
            rowAttributeType: $rowAttributeType
            filters: $filters
            columnDimension: $columnDimension
            columnAttributeType: $columnAttributeType
            limit: $limit
            offset: $offset
            frequency: $frequency
            dateRange: $dateRange
            metricType: $metricType
            priceType: $priceType
            kpiName: $kpiName
            selectedRow: $selectedRow
            selectedColumn: $selectedColumn
        ) {
            count
            data {
                rowAttributeName
                itemIndex
                isExpandable
                columnData {
                    colAttributeName
                    priceChangeData
                    __typename
                }
                __typename
            }
            __typename
        }
    }
`;
